<div class="container d-lg-none d-block">
  <div class="mt-4">
    <fgb-barcode [showCashBackToggle]="true"></fgb-barcode>
  </div>
</div>

<div class="container mt-4">
  <fgb-transaction-history
    [transactionTypes]="[transactionTypes.ecash, transactionTypes.payment]"
    [ecashView]="true"
  ></fgb-transaction-history>
</div>
